import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { errorState } from "../../../recoil/error/atom";
import ConsentPageTitle from "./ConsentPageTitle";
import DetailSection from "./DetailSection";
import PeriodConsent from "./PeriodConsent";
import HolderSignature from "./HolderSignature";
import DriverConsetSecondPage from "./DriverConsetSecondPage";
import styles from "./DriverConsent.module.scss";
import { validateDateString } from "../common/ValidationHelper";

const DriverConsent = (props) => {
    const popError = useSetRecoilState(errorState);

    const [fullName, setFullName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [licenceNumber, setLicenceNumber] = useState("");
    const [licenceVersion, setLicenceVersion] = useState("");
    const [dob, setDOB] = useState("");

    const [monthPeriod, setMonthPeriod] = useState("");
    const [untilDate, setUntilDate] = useState("");
    const [employmentDuration, setEmploymentDuration] = useState(true);
    
    const [signatureDate, setSignatureDate] = useState("");
    const [signature, setSignature] = useState("");

    const setDateData = (value) => {
        console.log("setDateData", value);
        setSignatureDate(value);
    };
    const setSignatureData = (data) => {
        setSignature(data);
    };

    const resetForm = () => {
        const value = "";
        setFullName(value);
        setLicenceNumber(value);
        setLicenceVersion(value);
        setCompanyName(value);
        setDOB(value);
        setMonthPeriod(value);
        setUntilDate(value);
        setEmploymentDuration(true);
        setSignatureDate(value);
        setSignature("");
    };

    const validateForm = () => {
        const isRequiredFieldFilled = fullName && licenceNumber && licenceVersion && companyName && dob && signature && signatureDate;

        const isPeriodConsentFilled = monthPeriod || untilDate || employmentDuration;
        const isValidSignature = signature && signatureDate;

        if (isRequiredFieldFilled && isPeriodConsentFilled && isValidSignature) {
            const isValidSignatureDate = validateDateString(signatureDate);
            const isValidDOBDate = validateDateString(dob);
            
            if (!isValidSignatureDate) {
                return { isValid: false, message: "Invalid signature date." };
            }
            if (!isValidDOBDate) {
                return { isValid: false, message: "Invalid DOB date." };
            }
            return {isValid: true, message: ""};
        }
        return {isValid: false, message: "Please fill in all required fields"};
    };

    const submitForm = () => {
        var { isValid, message } = validateForm();

        if (isValid) {
            const data = {
                interactiveDocument: "DriverConsent",
                licenceholdername: fullName,
                companyname: companyName,
                driverlicencenumber: licenceNumber,
                driverlicenceversion: licenceVersion,
                licenceholderdob: dob,
                periodmonth: monthPeriod,
                perioddate: untilDate,
                employmentduration: employmentDuration,
                signatureContent : signature,
                signaturedate:  signatureDate
            };
            props.submit(data).then( result => {
                if (result ) {
                    props.redirectToList();
                }
            });
        } else {
            popError([{
                type: "warning",
                title: "Warning",
                message: message
            }]);
        }
    };

    const setNameAndLicenceNumber = ({ name, value }) => {
        switch (name) {
            case "fullName":
                setFullName(value);
                break;
            case "licenceNumber":
                setLicenceNumber(value);
                break;
            case "licenceVersion":
                setLicenceVersion(value);
                break;
                case "companyName":
                setCompanyName(value);
                break;
            case "dob":
                setDOB(value);
                break;
            default:
                break;
        }
    };

      const setPeriodOfConsent = ({ name, value }) => {
        switch (name) {
            case "monthPeriod":
                setMonthPeriod(value);
                break;
            case "untilDate":
                setUntilDate(value);
                break;
            default:
                break;
        }
    };

    const setChoicesData = (value ) => {
        setEmploymentDuration(value);
        if (value) {
            setMonthPeriod("");
            setUntilDate("");
        }
    };

    return (
        <div className={`driver-consent-form ${styles.driverConsentForm}`}>
            <div className="container">
                <ConsentPageTitle />
                <DetailSection 
                    setNameData={setNameAndLicenceNumber}
                    fullName={fullName}
                    licenceNumber={licenceNumber}
                    companyName={companyName}
                    dob={dob}
                    licenceVersion={licenceVersion}
                />
                <PeriodConsent 
                    setPeriodOfConsent={setPeriodOfConsent}
                    setChoicesData={setChoicesData}
                    monthPeriod={monthPeriod}
                    untilDate={untilDate}
                    employmentDuration={employmentDuration}
                />
                <HolderSignature
                    setSignatureData={setSignatureData}
                    signature={signature}
                    signatureDate={signatureDate}
                    setDateData={setDateData}
                />
                <div className={`section ${styles.sectionGrey}`} style={{ backgroundColor: '#f0f0f0', padding: '20px 10px', marginTop: '-10px' }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className={styles.actionButton}>
                                <button className="btn btn-danger" type="button" onClick={resetForm}>
                                RESET FORM
                                </button>
                                &nbsp;&nbsp;
                                <button className="btn btn-info" type="button" onClick={submitForm}>
                                SUBMIT FORM
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div>11 | APPLYING TO USE DRIVER CHECK</div>
                <div className="pagebreak" />
                <DriverConsetSecondPage />
                <div>12 | APPLYING TO USE DRIVER CHECK</div>
            </div>  
        </div>
    );
};

export default DriverConsent;